/* eslint-disable linebreak-style */
import React from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setCurrentUserSuccess, setDeliveryAddressesSuccess} from '../../redux/user/user.actions'
import {loadCuloriSuccess,loadInformariSuccess, loadPreturiTabelareSuccess, loadFirmaSuccess, loadIndicatoriSuccess, loadProduseSuccess, loadMaterialeSuccess, loadOptionaleSuccess} from '../../redux/lookup/lookup.actions'
import {setLoading} from '../../redux/other/other.actions';
import {clearToken} from '../../strapi/strapi.utils.js';

class SignOut extends React.Component{
  async componentDidMount() {
    const {setCurrentUserSuccess, setDeliveryAddressesSuccess, loadCuloriSuccess,loadInformariSuccess, loadPreturiTabelareSuccess, loadFirmaSuccess, loadIndicatoriSuccess, loadProduseSuccess, loadMaterialeSuccess, loadOptionaleSuccess, setLoading}=this.props;
    await clearToken();
    setCurrentUserSuccess(null)
    setDeliveryAddressesSuccess([])
    loadCuloriSuccess([])
    loadInformariSuccess([])
    loadPreturiTabelareSuccess([])
    loadFirmaSuccess([])
    loadIndicatoriSuccess([])
    loadProduseSuccess([])
    loadMaterialeSuccess([])
    loadOptionaleSuccess([])
    setLoading(false)
    window.location.replace('/sign-in');
  }
      
  render () {
    return null;
  }
}

SignOut.propTypes = {
  setCurrentUserSuccess: PropTypes.func,
  setDeliveryAddressesSuccess:PropTypes.func
};

const mapDispatchToProps=dispatch=>({
  setCurrentUserSuccess:user=>dispatch(setCurrentUserSuccess(user)),
  setLoading:(boll)=>dispatch(setLoading(boll)),
  loadIndicatoriSuccess:(indicatori)=>dispatch(loadIndicatoriSuccess(indicatori)),
  loadInformariSuccess:(informari)=>dispatch(loadInformariSuccess(informari)),
  loadCuloriSuccess:(culori)=>dispatch(loadCuloriSuccess(culori)),
  loadOptionaleSuccess:(optionale)=>dispatch(loadOptionaleSuccess(optionale)),
  loadFirmaSuccess:(firma)=>dispatch(loadFirmaSuccess(firma)),
  loadPreturiTabelareSuccess:(preturitabelare)=>dispatch(loadPreturiTabelareSuccess(preturitabelare)),
  loadMaterialeSuccess:(materiale)=>dispatch(loadMaterialeSuccess(materiale)),
  loadProduseSuccess:(produse)=>dispatch(loadProduseSuccess(produse)),
  setDeliveryAddressesSuccess:addresses=>dispatch(setDeliveryAddressesSuccess(addresses))
})
export default connect(null,mapDispatchToProps)(SignOut);
